
import Vue from "vue";
import {Product} from "@/models/base";
import SizeTable from "@/models/base/size-table";
import SizeTableEntry from "@/models/base/size-table-entry";

export default Vue.extend({
	props: {
		product: {
			type: Object as () => Product,
			required: true
		},
		sizeTable: {
			type: Object as () => SizeTable,
			required: true
		}
	},
	computed: {
		entries():SizeTableEntry[] {
			return this.sizeTable.getSortedEntries();
		}
	},
	methods: {
		select(entry: SizeTableEntry | null){
			this.$emit("select", entry);
		}
	},
	i18nEx: {
		componentPrefix: "components.sales.Cashier"
	},
});
